export default __webpack_public_path__ + "static/media/reddit.c820f674.svg";